import RoleContext from "@/contexts/RoleContext";
import { useContext } from "react";

export const useRole = () => {
 return useContext(RoleContext);
};
